import store from "../store/index";
//-------------------
// change view round
//-------------------
export default function changeViewRound(dir) {
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let round = this_store.view_round;
  //---------------------------
  // increment/decrement round   (4 = arbitary hardcoded value)
  //---------------------------
  if (dir == "next") {
    if (round < this_store.arena.round + 4) {
      round++;
    }
  } else if (dir == "previous") {
    round--;
    //-----------------------------------
    // else set view round = arena round
    //-----------------------------------
  } else {
    round = this_store.arena.round;
  }
  store.commit("combat/setViewRound", round);
  return round
}
